<template>
  <div class="logo">
      <div class="logo-content" @click="logoClick">
        <img src="../../../static/images/logo.png" alt="">
         <!-- <p>{{ title }}</p> -->
      </div>
  </div>
</template>

<script>

export default {
  name: 'Logo',
  components: {
  },
  methods:{
      logoClick(){
          this.$router.push('/home');
      }
  },
  props: {
    title: {
      type: String,
      default: '课程制作平台',
      required: false
    },
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  }
}
</script>
<style lang="less" scoped="">
    .logo-content{
      height: 100%;
      display: flex;
      align-items: center;
      img{
        height: 40px;
      }
      p{
        margin: 0;
        padding: 0;
        padding-left: 8px;
        line-height: 20px;
      };
    }
</style>